<bodyanalytics-field-label
  [for]="inputId()"
  [text]="label()"
  [required]="required()"
  [hint]="hint()"
></bodyanalytics-field-label>

<div class="field-select">
  <select
    class="field-select__control"
    [class.field-select__control--invalid]="invalid()"
    [class.field-select__control--placeholder]="value() === null"
    [id]="inputId()"
    [required]="required()"
    [disabled]="disabled()"
    [attr.aria-invalid]="invalid() ? 'true' : null"
    [attr.aria-describedby]="describedBy()"
    [value]="value() === null ? '' : value()"
    (change)="handleChange($event)"
    (blur)="handleBlur()"
  >
    <option value="" [disabled]="required()">{{ placeholder() }}</option>
    @for (opt of options(); track opt.value) {
      <option [value]="opt.value" [disabled]="opt.disabled">{{ opt.label }}</option>
    }
  </select>
  <i class="bx bx-chevron-down field-select__chevron" aria-hidden="true"></i>
</div>

@if (error(); as e) {
  <p class="field-select__error" role="alert" [id]="errorId()">
    <i class="bx bx-error-circle" aria-hidden="true"></i>
    {{ e }}
  </p>
}
